import { ProductEventWithEcommerce, ProductFieldObject } from 'src/types';

export interface AddToBasketInitialEvent {
  ecommerce: null;
}

export interface AddToBasketEcommerce {
  ecommerce: {
    add: {
      products: [ProductFieldObject];
    };
  };
}

export type AddToBasketEvent = ProductEventWithEcommerce<
  'add_to_cart',
  'Add to basket',
  null,
  AddToBasketEcommerce
>;

export const ADD_TO_BASKET_SITESPECT_EVENT = 'addToCart';
